import React, { useState } from "react";

/**
 * Branded fallback image component. Falls back to an on-brand
 * SVG placeholder if the src URL fails (broken Cloudinary,
 * timeout, offline, etc.). Prevents blank spaces on the site.
 */
export default function SafeImage({ src, alt = "", className = "", ...rest }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div
        className={`flex items-center justify-center bg-[#b8af92] text-[#1A1A1A]/40 ${className}`}
        role="img"
        aria-label={alt || "Image unavailable"}
      >
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true">
          <rect x="6" y="10" width="36" height="28" stroke="currentColor" strokeWidth="1.5" fill="none" />
          <circle cx="16" cy="20" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
          <path d="M6 32l10-9 8 7 6-5 12 10" stroke="currentColor" strokeWidth="1.5" fill="none" />
        </svg>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      className={className}
      {...rest}
    />
  );
}
